export const countryList = {
  "Afghanistan": "Afghanistan",
  "Algeria": "Algeria",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antarctica": "Antarctica",
  "Antigua and Barbuda": "Antigua and Barbuda",
  "Argentina": "Argentina",
  "Armenia": "Armenia",
  "Aruba": "Aruba",
  "Australia": "Australia",
  "Austria": "Austria",
  "Azerbaijan": "Azerbaijan",
  "Bahamas": "Bahamas",
  "Bahrain": "Bahrain",
  "Bangladesh": "Bangladesh",
  "Barbados": "Barbados",
  "Belgium": "Belgium",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermuda",
  "Bhutan": "Bhutan",
  "Bolivia, Plurinational State of": "Bolivia, Plurinational State of",
  "Bonaire, Sint Eustatius and Saba": "Bonaire, Sint Eustatius and Saba",
  "Botswana": "Botswana",
  "Bouvet Island": "Bouvet Island",
  "Brazil": "Brazil",
  "British Indian Ocean Territory": "British Indian Ocean Territory",
  "Brunei Darussalam": "Brunei Darussalam",
  "Burkina Faso": "Burkina Faso",
  "Cabo Verde": "Cabo Verde",
  "Cambodia": "Cambodia",
  "Cameroon": "Cameroon",
  "Canada": "Canada",
  "Cayman Islands": "Cayman Islands",
  "Chad": "Chad",
  "Chile": "Chile",
  "China": "China",
  "Christmas Island": "Christmas Island",
  "Cocos (Keeling) Islands": "Cocos (Keeling) Islands",
  "Colombia": "Colombia",
  "Comoros": "Comoros",
  "Congo": "Congo",
  "Cook Islands": "Cook Islands",
  "Costa Rica": "Costa Rica",
  "Curaçao": "Curaçao",
  "Cyprus": "Cyprus",
  "Czechia": "Czechia",
  "Denmark": "Denmark",
  "Djibouti": "Djibouti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominican Republic",
  "Ecuador": "Ecuador",
  "Egypt": "Egypt",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Equatorial Guinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estonia",
  "Eswatini": "Eswatini",
  "Ethiopia": "Ethiopia",
  "Falkland Islands (Malvinas)": "Falkland Islands (Malvinas)",
  "Faroe Islands": "Faroe Islands",
  "Fiji": "Fiji",
  "Finland": "Finland",
  "France": "France",
  "French Guiana": "French Guiana",
  "French Polynesia": "French Polynesia",
  "French Southern Territories": "French Southern Territories",
  "Gabon": "Gabon",
  "Gambia": "Gambia",
  "Germany": "Germany",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Greece",
  "Greenland": "Greenland",
  "Grenada": "Grenada",
  "Guadeloupe": "Guadeloupe",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guinea",
  "Guinea-Bissau": "Guinea-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haiti",
  "Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
  "Holy See": "Holy See",
  "Honduras": "Honduras",
  "Hong Kong": "Hong Kong",
  "Hungary": "Hungary",
  "Iceland": "Iceland",
  "India": "India",
  "Indonesia": "Indonesia",
  "Ireland": "Ireland",
  "Isle of Man": "Isle of Man",
  "Israel": "Israel",
  "Italy": "Italy",
  "Jamaica": "Jamaica",
  "Japan": "Japan",
  "Jersey": "Jersey",
  "Jordan": "Jordan",
  "Kazakhstan": "Kazakhstan",
  "Kenya": "Kenya",
  "Kiribati": "Kiribati",
  "Korea, Republic of": "Korea, Republic of",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Kyrgyzstan",
  "Lao People's Democratic Republic": "Lao People's Democratic Republic",
  "Latvia": "Latvia",
  "Lesotho": "Lesotho",
  "Libya": "Libya",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Lithuania",
  "Luxembourg": "Luxembourg",
  "Macao": "Macao",
  "Madagascar": "Madagascar",
  "Malawi": "Malawi",
  "Malaysia": "Malaysia",
  "Maldives": "Maldives",
  "Malta": "Malta",
  "Marshall Islands": "Marshall Islands",
  "Martinique": "Martinique",
  "Mauritania": "Mauritania",
  "Mauritius": "Mauritius",
  "Mayotte": "Mayotte",
  "Mexico": "Mexico",
  "Micronesia, Federated States of": "Micronesia, Federated States of",
  "Monaco": "Monaco",
  "Mongolia": "Mongolia",
  "Montserrat": "Montserrat",
  "Morocco": "Morocco",
  "Mozambique": "Mozambique",
  "Myanmar": "Myanmar",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Netherlands",
  "New Caledonia": "New Caledonia",
  "New Zealand": "New Zealand",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolk Island",
  "Norway": "Norway",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestine, State of": "Palestine, State of",
  "Panama": "Panama",
  "Papua New Guinea": "Papua New Guinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Philippines",
  "Pitcairn": "Pitcairn",
  "Poland": "Poland",
  "Portugal": "Portugal",
  "Qatar": "Qatar",
  "Russian Federation": "Russian Federation",
  "Rwanda": "Rwanda",
  "Réunion": "Réunion",
  "Saint Barthélemy": "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha": "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis": "Saint Kitts and Nevis",
  "Saint Lucia": "Saint Lucia",
  "Saint Martin, (French part)": "Saint Martin, (French part)",
  "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Sao Tome and Principe",
  "Saudi Arabia": "Saudi Arabia",
  "Senegal": "Senegal",
  "Seychelles": "Seychelles",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapore",
  "Sint Maarten, (Dutch part)": "Sint Maarten, (Dutch part)",
  "Slovakia": "Slovakia",
  "Slovenia": "Slovenia",
  "Solomon Islands": "Solomon Islands",
  "South Africa": "South Africa",
  "South Georgia and the South Sandwich Islands": "South Georgia and the South Sandwich Islands",
  "South Sudan": "South Sudan",
  "Spain": "Spain",
  "Sri Lanka": "Sri Lanka",
  "Suriname": "Suriname",
  "Svalbard and Jan Mayen": "Svalbard and Jan Mayen",
  "Sweden": "Sweden",
  "Switzerland": "Switzerland",
  "Taiwan, Province of China": "Taiwan, Province of China",
  "Tajikistan": "Tajikistan",
  "Tanzania, United Republic of": "Tanzania, United Republic of",
  "Thailand": "Thailand",
  "Timor-Leste": "Timor-Leste",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad and Tobago",
  "Tunisia": "Tunisia",
  "Turkey": "Turkey",
  "Turkmenistan": "Turkmenistan",
  "Turks and Caicos Islands": "Turks and Caicos Islands",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "United Arab Emirates": "United Arab Emirates",
  "United Kingdom of Great Britain and Northern Ireland": "United Kingdom of Great Britain and Northern Ireland",
  "United States Minor Outlying Islands": "United States Minor Outlying Islands",
  "United States of America": "United States of America",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Uzbekistan",
  "Vanuatu": "Vanuatu",
  "Venezuela, Bolivarian Republic of": "Venezuela, Bolivarian Republic of",
  "Viet Nam": "Viet Nam",
  "Virgin Islands, British": "Virgin Islands, British",
  "Virgin Islands, U.S.": "Virgin Islands, U.S.",
  "Wallis and Futuna": "Wallis and Futuna",
  "Western Sahara": "Western Sahara",
  "Zambia": "Zambia",
  "Åland Islands": "Åland Islands",
};
